<template>
  <div>
    <div class="PopUpEnter" id="PopUp" v-show="showSignIn">
      <div class="PopUpFon"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock">
          <div class="PopUpName">ВОЙТИ</div>
          <div class="PopUpReg" @click="showSignUpForm()">Зарегистрироваться</div>
          <div class="PopUpClose" @click="hideSignInForm()"></div>
          <div class="PopUpZg">Войти с помощью соцсетей</div>
          <div class="SocIcons">
            <div class="Si Fb"></div>
            <div class="Si Vk"></div>
            <div class="Si Google"></div>
            <div class="Si Yandex"></div>
          </div>
          <div class="Rline"></div>
          <form id="LoginForm" method="post" @submit.prevent="doSignIn">
            <span id="LoginFormErrors" class="form_error" v-show="authError">{{ authError }}</span>
            <input type="email" class="Login" name="email" v-model="email" placeholder="Ваш email"><br>
            <input type="password" class="Pass" name="password" v-model="password" placeholder="******"><br>
            <input type="submit" class="BtEnter" value="Войти">
          </form>
          <div class="FogPass" @click="showForgetPassForm()">Забыли свой </br>логин или пароль?</div>
          <!-- <div class="Login">Ваш email или телефон</div>
          <div class="Pass">********</div>
          <div class="BtEnter">Войти</div> -->
        </div>
      </div>
    </div>

    <div class="PopUpForma" id="PopUpF" v-show="showSignUp">
      <div class="PopUpFon"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock">
          <div class="PopUpName">Зарегистрироваться</div>
          <div class="PopUpReg" @click="showSignInForm()">ВОЙТИ</div>
          <div class="PopUpClose" @click="hideSignUpForm()"></div>
          <div class="Rline"></div>
          <form id="SignupForm" method="post" @submit.prevent="doSignUp">
            <div class="MyName">
              <input type="text" name="name" placeholder="Имя Фамилия" v-model="name"><br>
              <span class="form_error" v-show="signUpErrors.name">{{ signUpErrors.name }}</span>
            </div>
            <div class="Email">
              <input type="email" name="email" placeholder="Ваш email" v-model="email"><br>
              <span class="form_error" v-show="signUpErrors.email">{{ signUpErrors.email }}</span>
            </div>
            <div class="PassNew">
              <input type="text" name="password" placeholder="Ваш пароль" v-model="password"><br>
              <span class="form_error" v-show="signUpErrors.password">{{ signUpErrors.password }}</span>
            </div>
            <div class="PassAgain">
              <input type="text" name="password_confirmation" placeholder="Еще раз" v-model="password_confirmation">
              <span class="form_error" v-show="signUpErrors.password_confirmation">{{ signUpErrors.password_confirmation }}</span>
            </div>
            <input type="submit" class="BtReg" value="Зарегистрироваться">
          </form>
          <div class="FogPass" @click="showForgetPassForm()">Забыли свой </br>логин или пароль?</div>
          <!-- <div class="Login">Ваш email или телефон</div>
          <div class="Pass">********</div>
          <div class="BtEnter">Войти</div> -->
        </div>
      </div>
    </div>

    <div class="PopUpForgetPass" id="PopUpForgetPass" v-show="showForgetPass">
      <div class="PopUpFon"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock">
          <div class="PopUpName">Сброс пароля</div>
          <div class="PopUpReg" @click="showSignInForm()">ВОЙТИ</div>
          <div class="PopUpClose" @click="hideForgetPassForm()"></div>

          <form id="ForgetPassForm" method="post" @submit.prevent="doResetPass">
            <span id="ForgetPassFormErrors" class="form_error" v-show="forgetPassError">{{ forgetPassError }}</span>
            <span v-show="forgetPassSuccess">Инструкция по смене пароля отправлена на емайл.</span>
            <input class="Login" name="email" v-model="email" placeholder="Ваш email или имя"><br>
            <input type="submit" class="BtEnter" value="Сбросить пароль">
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { pick } from 'lodash';
import { API_ROOT } from "@/utils/api_root";

export default {
  data() {
    return {
      authError: null,
      forgetPassError: null,
      forgetPassSuccess: false,
      signUpErrors: {},
      name: null,
      email: null,
      password: null,
      password_confirmation: null,
    };
  },
  computed: {
    showSignIn() {
      return this.$store.state.showSignIn;
    },
    showSignUp() {
      return this.$store.state.showSignUp;
    },
    showForgetPass() {
      return this.$store.state.showForgetPass;
    },
  },
  methods: {
    showSignInForm() {
      this.$store.commit('onShowSignIn');
    },
    showSignUpForm() {
      this.$store.commit('onShowSignUp');
    },
    showForgetPassForm() {
      this.$store.commit('onShowForgetPass');
    },
    hideSignInForm() {
      this.$store.commit('onHideSignIn');
    },
    hideSignUpForm() {
      this.$store.commit('onHideSignUp');
    },
    hideForgetPassForm() {
      this.$store.commit('onHideForgetPass');
    },
    doSignIn() {
      this.authError = null;
      this.$http.post(`${API_ROOT}/auth/sign_in`, { email: this.email, password: this.password })
        .then(response => {
          console.log('AuthPopups signin success', response);
          this.$store.commit('currentUser', response.data.data);
          this.$store.commit('onHideSignIn');
        })
        .catch(error => {
          console.log('AuthPopups signin error', error, error.response.data.errors);
          this.authError = error.response.data.errors[0];
        });
    },
    doSignUp() {
      console.log('AuthPopups doSignUp this', this);
      console.log('AuthPopups doSignUp API_ROOT', API_ROOT);
      const params = { name: this.name, email: this.email, password: this.password, password_confirmation: this.password_confirmation };
      console.log('AuthPopups doSignUp params', params);
      this.signUpErrors = {};

      this.$http.post(`${API_ROOT}/auth`, params)
        .then(response => {
          console.log('AuthPopups signup success', response);
          this.$store.commit('currentUser', response.data.data);
          this.$store.commit('onHideSignUp');
          this.$router.push({ name: 'id' });
        })
        .catch(error => {
          console.log('AuthPopups signup error', error, error.response.data);
          const errors = error.response.data.errors;
          this.signUpErrors = Object.fromEntries(
                                Object.entries(errors)
                                  .map(([k, v]) => {
                                    return [k, v.join(", ")];
                                  })
                              );
        });
    },
    doResetPass() {
      this.forgetPassError = null;
      this.forgetPassSuccess = false;
      this.$http.post(`${API_ROOT}/auth/password`, { email: this.email })
        .then(response => {
          console.log('AuthPopups resetPass success', response);
          this.forgetPassSuccess = true;
        })
        .catch(error => {
          console.log('AuthPopups resetPass error', error, error.response.data.errors);
          this.forgetPassError = error.response.data.errors[0];
        });
    }
  }
};
</script>

<style>
.PopUpEnter{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: #323938;
  border-top: 1px solid #ccc; */
  z-index: 10;
}

.PopUpForma{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: #323938;
  border-top: 1px solid #ccc; */
  z-index: 10;
}

.PopUpForgetPass{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.PopUpFon{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: #323938;
  opacity: 0.9;

}

.PopUpPanel{
  position: absolute;
  left: 50%;
  top: 15%;
}

.PopUpBlock{
  position: absolute;
  left: -200px;
  top: 0px;
  width: 400px;
  height: 410px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 10px 40px #000;
}

.PopUpName{
  position: absolute;
  top: 30px;
  left: 40px;
  width: 220px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 24px;
  color: #000000;
}

.PopUpZg{
  color: #d7d7d7;
}

#PopUp{
  /*display: none;*/
}

#PopUpF{
  /*display: none;*/
}

.PopUpReg{
  position: absolute;
  cursor: pointer;
  top: 35px;
  right: 40px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 16px;
  text-decoration: underline;
  color: #888888;
}

.PopUpReg:hover{
  color: #37bbd6;
}

.PopUpClose{
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: -40px;
  width: 40px;
  height: 40px;
  background-image: url("../assets/img/close.png");
  background-size: cover;
}

.PopUpZg{
  position: absolute;
  top: 90px;
  left: 40px;
  width: 220px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 16px;
  color: #888888;
}

.SocIcons{
  position: absolute;
  top: 120px;
  left: 40px;
  width: 220px;
}

.Si{
  width: 40px;
  height: 40px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  display: inline-table;
  opacity: 0.2;
  background-size: cover;
  cursor: default;
}

.Si.Fb{
  background-image: url("../assets/img/s-fb.png");
}
.Si.Vk{
  background-image: url("../assets/img/s-vk.png");
}
.Si.Google{
  background-image: url("../assets/img/s-google.png");
}
.Si.Yandex{
  background-image: url("../assets/img/s-yandex.png");
}

.Rline{
  position: absolute;
  top: 190px;
  left: 40px;
  width: 320px;
  border-top: 1px solid #ccc;
}

#LoginForm input:not([type="submit"]),
#SignupForm input:not([type="submit"]),
#ForgetPassForm input:not([type="submit"]){
  color: #000;
}

#SignupForm div{
  position: absolute;
}

#LoginFormErrors{
  position: absolute;
  top: 192px;
  left: 40px;
  font-family: "Open Sans";
  font-size: 9pt;
  font-style: italic;
  color: red;
}

.Login{
  position: absolute;
  top: 220px;
  left: 40px;
  width: 240px;
  height:30px;
  padding-left: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  color: #999;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.Pass{
  position: absolute;
  top: 270px;
  left: 40px;
  width: 240px;
  height:30px;
  padding-left: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  color: #999;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.MyName{
  /*position: absolute;*/
  top: 80px;
  left: 40px;
}

.MyName input {
  width: 240px;
  height:30px;
  padding-left: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  color: #ccc;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.Email{
  /*position: absolute;*/
  top: 135px;
  left: 40px;
}
.Email input{
  width: 240px;
  height:30px;
  padding-left: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  color: #ccc;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.PassNew{
  /*position: absolute;*/
  top: 220px;
  left: 40px;
}
.PassNew input{
  width: 240px;
  height:30px;
  padding-left: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  color: #ccc;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.PassAgain{
  /*position: absolute;*/
  top: 275px;
  left: 40px;
}
.PassAgain input{
  width: 240px;
  height:30px;
  padding-left: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  color: #ccc;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.BtEnter{
  position: absolute;
  top: 330px;
  right: 40px;
  width: 150px;
  height:40px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 18px;
  color: #fff;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #37bbd6;
  cursor: pointer;
}

.BtReg{
  position: absolute;
  top: 330px;
  right: 40px;
  width: 200px;
  height:40px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 18px;
  color: #fff;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #37bbd6;
  cursor: pointer;
}

.FogPass{
  position: absolute;
  top: 333px;
  left: 40px;
  width: 150px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 14px;
  color: #888;
  border: 0px solid #ccc;
  cursor: pointer;
}

.form_error {
  position: absolute;
  left: 12px;
  top: 32px;
  font-family: "Open Sans";
  font-size: 9pt;
  font-style: italic;
  color: red;
}

</style>
